__turbopack_context__.v({
  "actions": "RecoveryTreatmentsSection-module__QPDNXq__actions",
  "bookNowButton": "RecoveryTreatmentsSection-module__QPDNXq__bookNowButton",
  "description": "RecoveryTreatmentsSection-module__QPDNXq__description",
  "learnMoreButton": "RecoveryTreatmentsSection-module__QPDNXq__learnMoreButton",
  "list": "RecoveryTreatmentsSection-module__QPDNXq__list",
  "rightCol": "RecoveryTreatmentsSection-module__QPDNXq__rightCol",
  "row": "RecoveryTreatmentsSection-module__QPDNXq__row",
  "rowInner": "RecoveryTreatmentsSection-module__QPDNXq__rowInner",
  "sectionHeader": "RecoveryTreatmentsSection-module__QPDNXq__sectionHeader",
  "sectionRoot": "RecoveryTreatmentsSection-module__QPDNXq__sectionRoot",
  "shell": "RecoveryTreatmentsSection-module__QPDNXq__shell",
  "themedBodyText": "RecoveryTreatmentsSection-module__QPDNXq__themedBodyText",
  "themedSectionHeading": "RecoveryTreatmentsSection-module__QPDNXq__themedSectionHeading",
  "themedSectionLabel": "RecoveryTreatmentsSection-module__QPDNXq__themedSectionLabel",
  "title": "RecoveryTreatmentsSection-module__QPDNXq__title",
  "titleCol": "RecoveryTreatmentsSection-module__QPDNXq__titleCol",
  "treatmentImage": "RecoveryTreatmentsSection-module__QPDNXq__treatmentImage",
  "treatmentImageShell": "RecoveryTreatmentsSection-module__QPDNXq__treatmentImageShell",
});
